<template>
	<div>
		<section class="container-fluid mt-2">
			<div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <nav class="navbar navbar-breadcrumb navbar-expand-md bg-breadcrumb breadcrumb-borde">
                        <div class="mr-auto">
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb clearfix pt-3">
                                    <!-- <li class="breadcrumb-item active">
                                        <a @click="Regresar()">Volver</a>
                                    </li> -->
                                    <li class="breadcrumb-item active">Clientes</li>
                                </ol>
                            </nav>
                        </div>
                    </nav>
                </div>
            </div>

			<div class="row">
				<div class="col-md-12 col-lg-12 col-xl-12 mt-2">
					<Clist :isCrm="true" :pShowBtnAdd="ShowBtns" :ShowHead="false" @FiltrarC="Lista" :Filtro="Filtro" :regresar="true"  :Nombre="NameList"  :isModal="EsModal" :pConfigLoad="ConfigLoad" :isContactos="true" :ShowFilas="false">
						<template slot="cards">
							<div class="row row-cols-md-4 row-cols-lg-4 row-cols-xl-2 mt-3">
								<div v-for="(lista,key,index) in ListaClientes" :key="index" class="col-md-4 col-lg-4 col-xl-2 card-group">
									<div class="card mb-3 tarjetacliente" style="border:2px solid #0F3F87;cursor:pointer;"  @click="IrADetalle(lista)">
										<img height="160px" v-if="lista.Logo!=null && lista.Logo!=''" class="card-img-top" :src="Ruta+lista.Logo" alt=""/>
                                    	<div height="160px" v-else class="card-img-top" src="" alt="" style="background-color:#b4b4b4;padding:75px"></div>
										<div class="card-body pt-2">
											<div class="row mt-1">
												<div class="col-lg-12">
													<h6 class="m-0">{{lista.Nombre.toUpperCase() }}</h6>
													{{ lista.Ciudad }}
													<div class="mb-0 mr-0 ml-0">
														<b>Ordenes de Compra: </b> {{ lista.OrdenCompraCantidad }}
														<br>
														<b>Materiales: </b> ${{ formateoMillon(parseFloat(lista.MontoMaterial)) }}
														<br>
														<b>Equipos: </b> ${{ formateoMillon(parseFloat(lista.MontoEquipo)) }}
														<br>
														<b>Refacciones: </b> ${{ formateoMillon(parseFloat(lista.MontoRefaccion)) }}
													</div>
													<br>
												</div>
											</div>
										</div>
									</div>
									<div class="editar_contactos dropright">
                                        <button type="button" style="background:rgba(0,0,0,0); border:none;"
                                            title="Menu"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            >
                                                <i class="fa fa-ellipsis-v"></i>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-user" aria-labelledby="dropdownMenuButton">
                                            <div class="dropdown-menu-header">
                                                <h4 style="opacity:1" class="widget-nombre mt-1 text-center">Seleccione una opción</h4>
                                            </div>
                                            <!-- <a
                                                @click="AgregarTrabajador(lista.IdProyecto)"
                                                data-toggle="modal"
                                                :data-target="'#AgregarTrabajador'"
                                                data-backdrop="static"
                                                class="dropdown-item"
                                                >
                                                <i class="fa fa-user fa-fw-m"></i> Asignar Personal
                                            </a> -->

                                            <a
                                                @click="AbrirFactor(lista.IdSucursal)"
                                                data-toggle="modal"
                                                :data-target="'#cliente'"
                                                data-backdrop="static"
                                                class="dropdown-item"
                                                >
                                                <i class="fa fa-pencil fa-fw-m"></i> Editar
                                            </a>
                                        </div>
                                    </div>
								</div>
							</div>
						</template>
					</Clist>
					<Modal :Showbutton="true" :size="'modal-md'" :Nombre="'Factor Descuento'" :poBtnSave="oBtnSave" :pEmitSeccion="EmitSeccion" :NameModal="'cliente'">
						<template slot="Form">
							<Form :poBtnSave="oBtnSave"></Form>
						</template>
					</Modal>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Modal from '@/components/Cmodal.vue';
import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import Form from '@/views/modulos/distribuidor/clientes/Form.vue'
// import Menu from "../indexMenu.vue";

export default {
	name :'clientes',
	components :{
        Modal,
        Clist,
        Cbtnaccion,
        Form,
        // Menu,
    },
	data() {
		return {
			NombreSeccion: 'Clientes',
			FormName:'clientesForm',
			EsModal:true,
			NameList:"Clientes",
			EmitSeccion:"cliente",
			ListaClientes:[],
			TotalPagina:2,
            Pag:0,
            ShowBtns:false,
			Filtro:{
                Nombre:'',
                Placeholder:'Nombre..',
                TotalItem:0,
                Pagina:1,
                Entrada:30
            },
			oBtnSave:{
                isModal:true,
                EmitSeccion:'cliente',
                nombreModal:'cliente',
                disableBtn:false,
                toast:0,
                ShowSave:true,
                ShowCancel:true
            },
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			Ruta:""
		}
	},
	methods: {
		async Lista(){
			await this.$http.get('sucursalxdistribuidor/get',{
				params:{
					Nombre:this.Filtro.Nombre,
					Entrada:this.Filtro.Entrada,
					pag:this.Filtro.Pagina
				}
			}).then((res)=>{
				this.ListaClientes=res.data.data.rows;
				this.Ruta=res.data.data.ruta;
				this.Filtro.Entrada	= res.data.data.pagination.PageSize;
				this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				this.Filtro.Pagina = res.data.data.pagination.CurrentPage;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		AbrirFactor(IdSucursal){
			this.bus.$emit('NewModal_'+this.EmitSeccion,IdSucursal);
		},
		IrADetalle(item){
			this.$router.push({name:'distribuidorclienteinfo',params:{IdEmpresa:item.IdEmpresa,IdSucursal:item.IdSucursal}});
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
	},
	created() {
		this.bus.$off('List');
		this.Lista();
		this.bus.$on('List',()=>
        {
            this.Lista();
        });
	},
}
</script>

<style>

</style>
